import { Flex, Spinner } from "@chakra-ui/react";

export default function Blur({ show }) {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      transition="all 0.3s"
      backdropFilter={show ? "blur(20px)" : "none"}
      bg={show ? "rgba(0, 0, 0, 0.4)" : "transparent"}
      zIndex={show ? 10 : -10}
      borderRadius="12px"
    >
      {show && <Spinner color="white" size="xl" />}
    </Flex>
  );
}
